define('SchemaOrg.Product', [
    'SchemaOrg.BaseModule',
    'Product.Model',
    'Item.Model',
    'Store.Item.Stock.Helper',
    'SC.Configuration',
    'Backbone',
    'jQuery',
    'underscore',
    'Utils'
], function SchemaOrgPDP(
    SchemaOrgBaseModule,
    ProductModel,
    ItemModel,
    StoreStockHelper,
    Configuration,
    Backbone,
    jQuery,
    _,
    Utils
) {
    return _.extend({}, SchemaOrgBaseModule, {
        moduleType: 'product',
        init: function initialize(options) {
            var self = this;
            this.model = options.view.model;
            this.itemModel = options.view.model.get('item');
            this.reviews = [];
            this.pusher = options.pusher;
            self.addToPusher();
            Backbone.Events.on('SchemaOrg:Reviews', function schemaReviews(reviewCollection) {
                self.reviews = reviewCollection;
                self.addToPusher();
            });
        },
        sanitizeText: function sanitizeText(htmlText) {
            // To remove html tags
            var text;
            var div = document.createElement('div');
            div.innerHTML = htmlText;
            text = div.innerText;

            return text;
        },
        getChildQuery: function getChildQuery(childItem) {
            var productModel = new ProductModel(Utils.deepCopy(this.model));
            var matrixOptions = productModel.get('options').where({ isMatrixDimension: true });

            _.each(matrixOptions, function eachOption(option) {
                var optionObject = _.findWhere(option.get('values'), { label: childItem[option.get('itemOptionId')] });
                if (optionObject) {
                    option.set('value', {
                        internalid: optionObject.internalid,
                        label: optionObject.label
                    });
                }
            });

            return productModel.getQuery();
        },
        createJSONLD: function createJSONLD() {
            var self = this;
            var review = {};
            var offer = {};
            var itemBaseUrl = location.origin + this.itemModel.get('_url');
            var availableStores = SC.ENVIRONMENT.published.stores;
            // eslint-disable-next-line
            var description = this.sanitizeText(this.itemModel.get(Configuration.get('schemaOrg.pdpDescriptionField', 'storedescription')) || this.itemModel.get('storedetaileddescription'));
            var jsonLDObject = {
                '@context': 'http://schema.org',
                '@type': 'Product',
                'url': itemBaseUrl,
                'name': this.itemModel.get('_name'),
                'sku': this.itemModel.get('_sku'),
                'image': _.map(this.itemModel.get('_images'), function mapImages(image) {
                    return image.url;
                }),
                'brand': Configuration.get('siteSettings.displayname'),
                'description': jQuery('<div/>').html(description).text()
            };
            if (this.reviews.length > 0) {
                jsonLDObject.aggregateRating = {
                    '@type': 'AggregateRating',
                    'ratingValue': this.itemModel.get('_rating') || this.itemModel.get('rating') || 0,
                    'bestRating': Configuration.get('productReviews.maxRate', 5),
                    'worstRating': 0,
                    'ratingCount': this.reviews.length
                };
                jsonLDObject.review = [];
                _.each(this.reviews.models, function fnEachReviews(reviewModel) {
                    review = {
                        '@type': 'Review',
                        'name': reviewModel.get('title'),
                        'description': reviewModel.get('text'),
                        'author': reviewModel.get('writer').name,
                        'datePublished': reviewModel.get('created_on'),
                        'reviewRating': {
                            '@type': 'Rating',
                            'bestRating': Configuration.get('productReviews.maxRate', 5),
                            'ratingValue': reviewModel.get('_rating') || reviewModel.get('rating') || 0,
                            'worstRating': 0
                        }
                    };
                    jsonLDObject.review.push(review);
                });
            }
            if (this.itemModel.get('matrixchilditems_detail') && this.itemModel.get('matrixchilditems_detail').length) {
                jsonLDObject.offers = [];
                _.each(this.itemModel.get('matrixchilditems_detail'), function fnModels(item) {
                    _.each(availableStores, function eachStore(store) {
                        offer = {
                            '@type': 'Offer',
                            'priceCurrency': 'USD',
                            'price': item.custitem_aws_loyaltyprice_stored || item['pricelevel' + store.onlinePriceLevel],
                            'sku': item.itemid,
                            'availability': 'http://schema.org/' + ((item.isinstock || item.isbackorderable) ? 'InStock' : 'OutOfStock'),
                            'url': itemBaseUrl + self.getChildQuery(item)
                        };
                        offer.availableAtOrFrom = {
                            'branchCode': store.name.replace(/\s/g, '').toLowerCase()
                        };
                        jsonLDObject.offers.push(offer);
                    });
                });
            } else {
                jsonLDObject.offers = [];
                _.each(availableStores, function eachStore(store) {
                    offer = {
                        '@type': 'Offer',
                        'priceCurrency': 'USD',
                        'price': self.itemModel.get('custitem_aws_loyaltyprice_stored') || self.itemModel.get('pricelevel' + store.onlinePriceLevel),
                        'sku': self.itemModel.get('_sku'),
                        'url': itemBaseUrl,
                        'availability': 'http://schema.org/'
                            // eslint-disable-next-line no-underscore-dangle
                            + (StoreStockHelper._soldInStore(self.itemModel, store) && (!self.itemModel.get('_isfulfillable')
                                // eslint-disable-next-line no-underscore-dangle
                            || StoreStockHelper._stock(self.itemModel, store) > 0 || self.itemModel.get('isbackorderable')) ?
                                'InStock' : 'OutOfStock'),
                        'eligibleRegion': {
                            '@type': 'GeoCircle',
                            'address': {
                                '@type': 'PostalAddress',
                                'addressLocality': store.city,
                                'addressRegion': store.state,
                                'postalCode': store.zip,
                                'streetAddress': store.addr1
                            }
                        }
                    };
                    offer.availableAtOrFrom = {
                        'branchCode': store.name.replace(/\s/g, '').toLowerCase()
                    };
                    jsonLDObject.offers.push(offer);
                });
            }
            return jsonLDObject;
        }
    });
});
